import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "../lib/api";

// Any path that only a scanner / scraper ever asks for.
const SUSPICIOUS = /(\.env|\.git|wp-admin|wp-login|xmlrpc|phpmyadmin|administrator|config\.(json|php)|backup\.sql|\.aws|credentials|cgi-bin|eval-stdin|boaform|HNAP1)/i;

export default function NotFoundPage() {
  const loc = useLocation();

  useEffect(() => {
    const path = loc.pathname + loc.search;
    if (SUSPICIOUS.test(path)) {
      // fire-and-forget — never block the user, never surface errors
      api.post("/security/probe", {
        path,
        referrer: document.referrer || "",
      }).catch(() => {});
    }
  }, [loc.pathname, loc.search]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6" data-testid="not-found-page">
      <p className="text-6xl font-display font-bold text-[#0B0F0D]">404</p>
      <p className="mt-3 text-lg text-slate-600">That page isn’t here.</p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#0E2E22] text-[#D4AF37] font-bold text-sm hover:bg-[#0B0F0D] transition-colors"
      >
        Back to the dictionary
      </Link>
    </div>
  );
}
